(function() {
    class FreeGiftBlockAdev extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // this.buttons = this.querySelectorAll('.ai-free-gift-button-{{ ai_gen_id }}');
        this.buttons = this.querySelectorAll('.ai-free-gift-button-ai_gen_id');
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            this.handleAddToCart(e.currentTarget);
          });
        });
      }

      async handleAddToCart(button) {
        const variantId = button.getAttribute('data-product-id');
        
        if (!variantId) {
          console.error('No variant ID found');
          return;
        }

        button.disabled = true;
        const originalText = button.textContent;
        // button.textContent = '{{ block.settings.adding_text }}';
        button.textContent = this.getAttribute('data-adding-text');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                '_free_gift': 'true'
              }
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          button.textContent = this.getAttribute('data-added-text');

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);

          if (typeof window.dispatchEvent === 'function') {
            window.dispatchEvent(new Event('cart:refresh'));
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

        } catch (error) {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error - Try again';
          
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        }
      }
    }

    customElements.define('free-gift-block-adev', FreeGiftBlockAdev);
  })();